import React, { useState, useRef, useEffect } from 'react';
import api from '../services/api';
import s from './AssistenteIA.module.css';

// Assistente IA interno — chat simples pra equipe perguntar em linguagem
// natural sobre dados do próprio ERP (vendas, estoque, financeiro). Toda
// pergunta passa por ferramentas controladas no backend (nunca acesso
// direto ao banco) — ver backend/src/services/ia/.
export default function AssistenteIA() {
  const [mensagens, setMensagens] = useState([
    { autor: 'ia', texto: 'Oi! Pode me perguntar sobre vendas, estoque, clientes ou financeiro da loja.' },
  ]);
  const [pergunta, setPergunta] = useState('');
  const [enviando, setEnviando] = useState(false);
  const fimRef = useRef(null);

  useEffect(() => {
    fimRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [mensagens]);

  const enviar = async (e) => {
    e.preventDefault();
    const texto = pergunta.trim();
    if (!texto || enviando) return;
    setMensagens(prev => [...prev, { autor: 'usuario', texto }]);
    setPergunta('');
    setEnviando(true);
    try {
      const { data } = await api.post('/ia/perguntar', { pergunta: texto });
      setMensagens(prev => [...prev, { autor: 'ia', texto: data.resposta, ferramentas: data.ferramentas_usadas }]);
    } catch (err) {
      const msg = err.response?.data?.erro || 'Não consegui falar com o assistente agora.';
      setMensagens(prev => [...prev, { autor: 'ia', texto: msg, erro: true }]);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className={s.container}>
      <h2 className={s.titulo}>🤖 Assistente IA</h2>
      <div className={s.chat}>
        {mensagens.map((m, i) => (
          <div key={i} className={`${s.bolha} ${m.autor === 'usuario' ? s.bolhaUsuario : s.bolhaIa} ${m.erro ? s.bolhaErro : ''}`}>
            <div className={s.texto}>{m.texto}</div>
            {m.ferramentas?.length > 0 && (
              <div className={s.ferramentas}>
                consultou: {m.ferramentas.map(f => f.nome).join(', ')}
              </div>
            )}
          </div>
        ))}
        {enviando && <div className={`${s.bolha} ${s.bolhaIa}`}><div className={s.texto}>Consultando...</div></div>}
        <div ref={fimRef} />
      </div>
      <form className={s.form} onSubmit={enviar}>
        <input
          className={s.input}
          value={pergunta}
          onChange={e => setPergunta(e.target.value)}
          placeholder="Ex: quanto vendi hoje?"
          disabled={enviando}
          autoFocus
        />
        <button className={s.btnEnviar} type="submit" disabled={enviando || !pergunta.trim()}>Enviar</button>
      </form>
    </div>
  );
}
